/**
 * "ResizeObserver loop completed with undelivered notifications." 양성 경고 차단 (개발 전용).
 * 콜백을 rAF로 한 프레임 미뤄 전달 사이클 내 동기 재측정 루프를 끊는다. CRA 오버레이가 이 경고를
 * 런타임 에러 화면으로 띄우는 것을 막기 위함. index.js 최상단에서 import해 ResizeObserver보다 먼저 적용.
 */
if (
    process.env.NODE_ENV === "development" &&
    typeof window !== "undefined" &&
    typeof window.ResizeObserver === "function"
) {
    const NativeResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class PatchedResizeObserver extends NativeResizeObserver {
        constructor(callback) {
            super((entries, observer) => {
                window.requestAnimationFrame(() => {
                    callback(entries, observer);
                });
            });
        }
    };
}
